import StimulusTomSelect from "stimulus-tom-select";

// サーバ側インクリメンタル検索つきの顧客セレクタ（tom-select）。
// 顧客が大量（数千〜数万）でも全件をプリロードせず、入力に応じて候補を取得する。
//
// 使い方:
//   <%= f.select :customer_id, options, { include_blank: ... },
//         data: { controller: "customer-search",
//                 "customer-search-url-value": admin_customers_path(format: :json) } %>
//
// エンドポイントは ?keyword=<入力> で [{ value, text }] の配列を返す想定。
// excludedIds に入れた顧客は、候補に出さない（一斉送信の作成画面で、宛先に入れた人を外すのに使う）。
export class CustomerSearchController extends StimulusTomSelect {
  static values = { url: String, options: Object, excludedIds: Array };

  initTomSelect() {
    this.options = {
      valueField: "value",
      labelField: "text",
      searchField: ["text"],
      allowEmptyOption: true, // 「すべての顧客」（空欄）に戻せるようにする
      loadThrottle: 300, // 入力ごとの過剰リクエストを抑制
      // 候補はサーバが絞り込んで返すので、tom-select の手元ではもう一度絞り込まない。
      // 絞り込むと、姓名をつなげて探したとき（「山田太郎」）に、候補の「山田 太郎」が空白のせいで消える。
      score: () => () => 1,
      load: (query, callback) => {
        if (query.length < 1) return callback();

        // 前の検索の候補が混ざらないよう、取り直す前に捨てる（選んでいる顧客は残る）。
        this.select.clearOptions();

        const url = `${this.urlValue}?keyword=${encodeURIComponent(query)}`;
        fetch(url, { headers: { Accept: "application/json" } })
          .then((response) => response.json())
          .then((json) => {
            const excluded = new Set(this.excludedIdsValue.map(String));
            callback(json.filter((option) => !excluded.has(String(option.value))));
          })
          .catch(() => callback());
      },
      ...this.optionsValue,
    };
    super.initTomSelect();
  }

  // tom-select は取った候補と検索の結果を手元に残すため、外す人が変わったら捨てて、次の検索で取り直させる。
  excludedIdsValueChanged() {
    this.select?.clearOptions();
  }
}
